import { apiClient } from "../../../../../api/client";
import { ApiResponse } from "../../../../../types";
import { SearchParams, SearchResponse } from "../types";

export const saldoService = {
  async searchSaldo(
    params: SearchParams
  ): Promise<ApiResponse<SearchResponse>> {
    return apiClient.post("/gestorEntregoSaldo", params);
  },
};
